<template>
  <div id="error-view" class="text-xs-center">
    <h1>Erreur {{status}}</h1>
    {{route}}
    <p>{{message}}</p>
    <v-btn @click="$router.push('/')">Retour</v-btn>
  </div>
</template>

<script>
export default {
  name: 'error-view',
  props: {
    status: Number,
    route: String,
    message: String
  }
}
</script>
